/*
 * @Author: your name
 * @Date: 2021-01-19 14:01:42
 * @LastEditTime: 2022-11-08 16:49:26
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/router/tab-user/index.js
 */
const tabUser = [
  /**
   * Input tab code page
   * @param venueId {String} venueId
   */
  /**
   * 输入 tab code 页
   * @param venueId {String} venue 的 id
   */
  {
    path: '/v/:venueId/tab-user/pay',
    props: true,
    name: 'tab-user-pay',
    meta: {
      barShow: true,
      barTitle: 'Pay with tab',
      showArrow: true,
    },
    component: () => import('views/tab-user/pay')
  },

  /**
   * Create tab page
   * @param venueId {String} venueId
   */
  /**
   * 创建 tab 的页面
   * @param venueId {String} venue 的 id
   */
  {
    path: '/v/:venueId/tab-user/start-tab',
    props: true,
    name: 'start-tab',
    meta: {
      barShow: true,
      barTitle: 'Start a tab',
      showArrow: true,
    },
    component: () => import('views/tab-user/start-tab')
  },

  /**
   * Display page after the order is successfully paid with tab
   * @param venueId {String} venueId
   * @param orderId {String} orderId
   */
  /**
   * 订单用 tab 支付成功后的展示页
   * @param venueId {String} venue 的 id
   * @param orderId {String} order 的 id
   */
  {
    path: '/v/:venueId/tab-order-received/:orderId',
    name: 'order-received',
    props: true,
    meta: {
      barShow: true,
      showArrow: true,
      barTitle: 'Order received',
    },
    component: () => import('views/tab-user/tab-order-received')
  },
]

export default tabUser